import { render, staticRenderFns } from "./PrivacyDetailContent.vue?vue&type=template&id=2ffeed02&scoped=true"
import script from "./PrivacyDetailContent.vue?vue&type=script&lang=js"
export * from "./PrivacyDetailContent.vue?vue&type=script&lang=js"
import style0 from "./PrivacyDetailContent.vue?vue&type=style&index=0&id=2ffeed02&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ffeed02",
  null
  
)

export default component.exports